import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter, Route, Link, Switch, HashRouter } from 'react-router-dom';
import createReactClass from 'create-react-class';

interface LinkedInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  valueLink?: {
    value: any;
    requestChange: (value: any) => void;
  };
  checkedLink?: {
    value: boolean;
    requestChange: (value: boolean) => void;
  };
}

type LinkedInputComponent = React.ComponentClass<LinkedInputProps>;
// disable-next-line @typescript-eslint/no-require-imports
const LinkedInput: LinkedInputComponent = require('react-linked-input');

export { LinkedInput };
export type { LinkedInputProps };

declare global {
  interface Window {
    React: typeof React;
    ReactDOM: typeof ReactDOM;
    createReactClass: typeof createReactClass;
    LinkedInput: LinkedInputComponent;
    Router: typeof BrowserRouter;
    Route: typeof Route;
    Link: typeof Link;
    Switch: typeof Switch;
    HashRouter: typeof HashRouter;
  }
}

// 型安全なグローバル代入のためのヘルパー関数
function setGlobalProperty<T>(key: string, value: T): void {
  (global as any)[key] = value;
}

// グローバル変数の設定
setGlobalProperty('React', React);
setGlobalProperty('ReactDOM', ReactDOM);
setGlobalProperty('createReactClass', createReactClass);
setGlobalProperty('LinkedInput', LinkedInput);
setGlobalProperty('Router', BrowserRouter);
setGlobalProperty('Route', Route);
setGlobalProperty('Link', Link);
setGlobalProperty('Switch', Switch);
setGlobalProperty('HashRouter', HashRouter);
